import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Lazy store resolution: a module-scope import here closes a cycle
// (stores -> components -> mixins -> classes). See scripts/find-import-cycles.py.
// eslint-disable-next-line global-require
const useGeneralStore = (...args) => require("%/dynamic-component-editor/stores/general-store").useGeneralStore(...args);
// eslint-disable-next-line global-require
const useFanPublicationStore = (...args) => require("%/dynamic-component-editor/stores/fan-publication-store").default(...args);


export default class StoryEntity extends BaseOption {
  static userInterfaceComponent = () => {
    return {
      label: "Story",
      component: inspectorTools.AUTOCOMPLETE,
      props: {
        isAsync: true,
        showAllResultsOnClick: true,
        sourceUrl: () => {
          return useGeneralStore().apiV1 + `/publication/${useFanPublicationStore().publicationId}/stories/autocomplete`;
        },
        itemValueKey: "value",
        itemLabelKey: "label",
        placeholder: "Search stories...",
        runInitialSearch: true,
      },
    };
  };

  static defaultValue = "";
}
